import React from "react";
import { Row, Col } from "react-bootstrap";
import PropTypes from "prop-types";
import { FiCheck } from "react-icons/fi";
import { formatValue } from "../../../MarketplaceCheckout/_components/FinancialSummary";

const HotelSummary = ({ envisionData, getHotelRoom, getHotelNights, getHotelDailyPoints, getHotelTaxPoints, getHotelDailyMoney, getHotelTaxMoney, displayMode, fator, getCancellationPolicy, discount = 0 }) => {
  if (!envisionData) return null;

  const dailyLabel = formatValue(displayMode, getHotelDailyMoney?.() || 0, getHotelDailyPoints());
  const taxLabel = formatValue(displayMode, getHotelTaxMoney?.() || 0, getHotelTaxPoints());

  const convertToPoints = (value) => fator > 0 ? value / fator : 0;
  const discountPoints = Math.ceil(convertToPoints(Number(discount) || 0));
  const showDiscount = (Number(discount) || 0) > 0 || discountPoints > 0;
  const discountLabel = formatValue(displayMode, Number(discount) || 0, discountPoints);

  return (
    <div id="hotelCard" className="mb-3">
      <Row className="mb-4">
        <Col>
          <p className="font-wl-500 text-md color-text-dark mb-0">Quarto</p>
          <p className="text-sm text-muted mb-0">
            {getHotelRoom()?.name || "(Nome do modelo do quarto)"}
          </p>
          {getCancellationPolicy() && (
            <p
              className="text-sm mb-0 mt-2 d-flex align-items-center"
              style={{
                color: getCancellationPolicy().isFree ? "#157347" : "var(--text-dark)",
                fontWeight: 500,
              }}
            >
              {getCancellationPolicy().isFree && <FiCheck className="me-2" size={14} />}
              {getCancellationPolicy().title}
            </p>
          )}
        </Col>
      </Row>

      <Row className="mb-2">
        <Col>
          <p className="text-sm text-muted mb-0">
            {getHotelNights()} diária{getHotelNights() > 1 ? "s" : ""}
          </p>
        </Col>
        <Col className="text-end">
          <p className="text-sm color-text-dark mb-0">
            {dailyLabel}
          </p>
        </Col>
      </Row>

      <Row className="mb-2">
        <Col>
          <p className="text-sm text-muted mb-0">Taxa</p>
        </Col>
        <Col className="text-end">
          <p className="text-sm color-text-dark mb-0">
            {taxLabel}
          </p>
        </Col>
      </Row>

      {showDiscount && (
        <Row className="mb-2">
          <Col>
            <p className="text-sm text-muted mb-0">Cupom de desconto</p>
          </Col>
          <Col className="text-end">
            <p
              className="text-sm mb-0"
              style={{ color: "#2D8D68", fontWeight: 500 }}
            >
              -{discountLabel}
            </p>
          </Col>
        </Row>
      )}
    </div>
  );
};

HotelSummary.propTypes = {
  envisionData: PropTypes.object,
  getHotelRoom: PropTypes.func.isRequired,
  getHotelNights: PropTypes.func.isRequired,
  getHotelDailyPoints: PropTypes.func.isRequired,
  getHotelTaxPoints: PropTypes.func.isRequired,
  getHotelDailyMoney: PropTypes.func,
  getHotelTaxMoney: PropTypes.func,
  displayMode: PropTypes.string,
  fator: PropTypes.number,
  getCancellationPolicy: PropTypes.func.isRequired,
  discount: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default HotelSummary;
